import type { FormEvent } from 'react';
import { createPortal } from 'react-dom';
import { NewsletterSignup } from '@/components/NewsletterSignup';
import { useSubscribeToNewsletter } from '@/hooks/useSubscribeToNewsletter';

const newletterPortal = document.querySelector('.newsletter-signup__form');

export const useNewsletterSignup = () => {
  const { hasError, isPending, isSubscribed, subscribeToNewsletter } =
    useSubscribeToNewsletter();

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!isPending) {
      const formData = new FormData(e.currentTarget);
      const email = formData.get('newsletterEmail');

      // Trimmed before posting so a stray leading/trailing space is not what the server sees -
      // "markeverard@hotmail.com   " was one of the addresses that dead-lettered in #2922. The
      // server trims too; this just keeps the request clean.
      const trimmedEmail = typeof email === 'string' ? email.trim() : '';

      if (trimmedEmail) {
        subscribeToNewsletter({ email: trimmedEmail });
      }
    }
  };

  return newletterPortal
    ? createPortal(
        <NewsletterSignup
          handleSubmit={handleSubmit}
          hasError={hasError}
          isPending={isPending}
          isSubscribed={isSubscribed}
        />,
        newletterPortal,
      )
    : null;
};
